import get from 'lodash/get';
import { type Alias, type OpenApiGetPageContextRequest } from '#shared/api/schema';
import {
    CONSTRUCTOR_BLOG_ENTRY_ALIAS,
    CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS,
    CONSTRUCTOR_PRODUCT_CARD_ALIAS,
    CONSTRUCTOR_PRODUCT_REVIEWS_ALIAS,
    CONSTRUCTOR_PRODUCTS_BUNDLE_ALIAS,
} from '../model/constants';

export const CONSTRUCTOR_PAGE_ALIASES_WITH_CONTEXT = new Set<NonNullable<Alias>>([
    CONSTRUCTOR_PRODUCT_CARD_ALIAS,
    CONSTRUCTOR_PRODUCT_REVIEWS_ALIAS,
    CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS,
    CONSTRUCTOR_BLOG_ENTRY_ALIAS,
    CONSTRUCTOR_PRODUCTS_BUNDLE_ALIAS,
]);

export const isConstructorPageAliasWithContext = (alias: string | undefined): alias is NonNullable<Alias> =>
    Boolean(alias && CONSTRUCTOR_PAGE_ALIASES_WITH_CONTEXT.has(alias as NonNullable<Alias>));

const optionalId = (value: unknown): string | undefined =>
    typeof value === 'string' && value.length > 0 ? value : undefined;

export const mapStaticContextToPageContextRequest = (
    pageAlias: NonNullable<Alias>,
    staticContext: unknown
): OpenApiGetPageContextRequest => {
    return {
        page_alias: pageAlias,
        variant_id: optionalId(get(staticContext, ['product', 'variantId'])),
        category_id: optionalId(get(staticContext, ['categoryCollection', 'categoryId'])),
        collection_id: optionalId(get(staticContext, ['categoryCollection', 'collectionId'])),
        blog_entry_id: optionalId(get(staticContext, ['blogEntryDto', 'blogEntryId'])),
    };
};
